module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-panel', {
    attrs: {
      "title": "常见问题"
    }
  }, [_c('ul', _vm._l((_vm.questions), function(question, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "user",
      style: ({
        backgroundImage: 'url(' + _vm.questionIcon + ')'
      })
    }, [_vm._v(_vm._s(question.q))])]), _vm._v(" "), _c('p', {
      staticClass: "message",
      domProps: {
        "innerHTML": _vm._s(question.a)
      }
    })])
  }))]), _vm._v(" "), (_vm.allQuestions.length > 2) ? _c('div', {
    staticClass: "footer theme-color"
  }, [_c('span', {
    staticClass: "more",
    class: {
      'more--active': _vm.showMore
    },
    on: {
      "click": function () {
        this$1.$emit('on-reActiveNav');
        _vm.showMore = !_vm.showMore
      }
    }
  }, [_vm._v(_vm._s(_vm.moreTips))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65a4f3b1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question.vue
// module id = 674
// module chunks = 1